import React, { useEffect, useState } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import CustomButton from "../../components/CustomButton";
import CustomTable from "../../components/CustomTable";
import { request } from "../../components/Vouchers/dummyData";
import moment from "moment";
import DatePicker from "../../components/FormFields/DatePicker";
import RadioButton from "../../components/FormFields/RadioButtons";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { displayDateFormat, downloadReports } from "../../utils/helpers";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const AdminRequests = () => {
  const { data = [], apiCall } = useApi();
  const navigation = useNavigate();
  const [selectedRadio, setSelectedRadio] = useState("ALL_REQUEST");
  const [checkboxPropData, setCheckboxPropData] = useState([]);
  const [searchParams] = useSearchParams();
  const {
    selectedStores,
    user: { userLabel = "" },
  } = useAuth();
  const { storeCode = ""} = selectedStores?.storeDetails || {}
  const [startDate, setStartDate] = useState(
    moment(
      searchParams.get("startDate") || moment().subtract({ days: 7 }).toDate()
    ).toDate()
  );
  const [endDate, setEndDate] = useState(
    moment(searchParams.get("endDate") || new Date()).toDate()
  );

  const onChangeRadio = (e, status) => {
    setSelectedRadio(e.target.value);
    RaiseArequestTableDataApi(startDate, endDate, status);
  };

  // useEffect(() => {
  //   RaiseArequestTableDataApi(startDate, endDate, selectedRadio);
  // }, []);


  const isStoreActive = userLabel == "Store";
  useEffect(() => {
    // if (isStoreActive) {
      RaiseArequestTableDataApi(startDate, endDate, selectedRadio);
    // } else {
    //   if (storeCode.length > 0 && storeCode.length !== 0) {
    //     RaiseArequestTableDataApi(startDate, endDate, selectedRadio);
    //   }
    // }
  }, [selectedStores, endDate]);

  const RaiseArequestTableDataApi = (start, end, status) => {
    navigation({
      pathname: window.location.pathname,
      search: createSearchParams({ startDate: start, endDate: end }).toString(),
    });

    // if(storeCode.length > 0){
      apiCall({
        url: apiUrls.dmsService.getRecords,
        dataToSend: {
          startDate: moment(start).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
          metadataSchemaId: 13,
          endDate: moment(end || start)
            .endOf("d")
            .format("YYYY-MM-DD HH:mm:ss"),
          searchText: "",
          status: status === "ALL_REQUEST" ? null : status,
        },
        method: "post",
        processData: true,
        accessor: "documents",
      });
    // }
  };

  const onChangeDate = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (end !== null) RaiseArequestTableDataApi(start, end, selectedRadio);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Date",
        accessor: "date",
        Cell: (props) => {
          return (
            <div>{moment(props?.row?.original?.date).format(displayDateFormat)}</div>
          );
        },
      },
      {
        Header: "Request For",
        accessor: "request_for",
        Cell: (props) => {
          const value = props?.row?.original;
          if (!value) {
            return "-";
          }
          return (
            <div className="py-4">
              <div className="font-size-small">{value?.head}</div>
              {/* <div className="text-[1.4rem] text-[var(--ultraLightGray)]">
                {value?.sub_head}
              </div> */}
            </div>
          );
        },
      },
      {
        Header: "Description",
        accessor: "description",
        Cell: (props) => {
          const value = props?.row?.original?.description;
          return value || "-";
        },
      },
      {
        Header: "Quantity",
        accessor: "qty",
        Cell: (props) => {
          const value = props?.row?.original?.quantity;
          return value ? Number(value).toFixed(2) : "-";
        },
      },
      {
        Header: "Rate (₹)",
        accessor: "rate",
        Cell: (props) => {
          const value = props?.row?.original?.rate;
          return value ? Number(value).toFixed(2) : "-";
        },
      },
      {
        Header: "Total Amount (₹)",
        accessor: "amount",
        Cell: (props) => {
          const value = props?.row?.original?.amount;
          let amount;
          if(typeof value == "string"){
            amount = Number(value).toFixed(2);
          } else {
            amount = value
          }
          return amount ? Number(amount).toFixed(2) : "-";
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: (props) => {
          const value = props?.row?.original?.L1?.status;
          if (!value) {
            return "-";
          }
          return (
            <div
              className={
                value === "Approved"
                ? "text-[var(--successGreen)]"
                : value === "Rejected"
                ? "text-[var(--textRed)]"
                : value === "Pending" ? "text-[var(--pendingYellow)]" : value === "Partially Approved" ? "text-[var(--successGreen)]" :  "text-[var(--pendingYellow)]"
              }
            >
              {value}
            </div>
          );
        },
      },
    ],
    []
  );

  let reportData = [
    {
      sheet: "Reports",
      columns: [
        { label: "Date", value: (row) => row.date }, // Top level data
        { label: "Request For", value: (row) => row.head }, // Top level data
        // { label: "Sub Head", value: (row) => row.sub_head }, // Top level data
        { label: "Description", value: (row) => row.description }, // Top level data
        { label: "Rate", value: (row) => row.rate }, // Top level data
        { label: "Quantity", value: (row) => row.quantity }, // Top level data
        { label: "Total Amount", value: (row) => row.amount }, // Top level data
        { label: "Approval Status", value: (row) => row.approval_status }, // Top level data
      ],
      content: checkboxPropData.map((i) => i.original),
    },
  ];

  let reportSettings = {
    fileName: selectedRadio + " Report", // Name of the resulting spreadsheet
    extraLength: 3, // A bigger number means that columns will be wider
    writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
    writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
    RTL: false, // Display the columns from right-to-left (the default value is false)
  };

  const downloadRequestReports = () => {
    downloadReports(reportData, reportSettings);
  };

  const setCheckData = (val) => {
    setCheckboxPropData(val);
  };

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Request"
        showBack={false}
        containerClassName="mt-14"
        renderRight={() => {
          return (
            <CustomButton
              title="Raise a Request"
              wrapperClassName="!px-10"
              onClick={() => navigation("/raisearequest")}
            />
          );
        }}
      />

      <div className="bg-[var(--whiteColor)] rounded-[1rem] min-h-[10rem] mt-3 flex flex-col justify-center px-4 py-6 gap-y-5">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-x-5">
            <RadioButton
              title="All Request"
              value="ALL_REQUEST"
              checked={selectedRadio === "ALL_REQUEST"}
              onChange={(e) => onChangeRadio(e, null)}
            />
            <RadioButton
              title="Pending"
              value="PENDING"
              checked={selectedRadio === "PENDING"}
              onChange={(e) => onChangeRadio(e, "PENDING")}
            />
            <RadioButton
              title="Approved"
              value="APPROVED"
              checked={selectedRadio === "APPROVED"}
              onChange={(e) => onChangeRadio(e, "APPROVED")}
            />
          </div>
          <div className="flex items-center gap-x-3">
            <div className="font-size-medium">Date Range</div>
            <DatePicker
              startDate={startDate}
              endDate={endDate}
              onChange={onChangeDate}
              maxDate={new Date()}
              dateRange
            />
          </div>
        </div>
        <CustomTable
          data={data}
          columns={columns}
          showCheckboxes={true}
          onCheckboxSelect={(selectedCheckBoxes) => {
            if (data?.length) {
              setCheckData(selectedCheckBoxes);
            }
          }}
          centerAlignedColumns={[
            "l1_status",
            "l2_status",
            "amount",
            "ac_status",
            "approved_amount",
          ]}
        />
        <div
          className={`mt-4 flex items-center justify-end gap-x-5 ${
            checkboxPropData.length > 0 ? "" : "disabled-kv"
          }`}
        >
          <CustomButton
            onClick={downloadRequestReports}
            title="Download"
            wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
          />
        </div>
      </div>
    </div>
  );
};

export default AdminRequests;
